import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EntityLogin from './pages/EntityLogin';
import CustomerLogin from './pages/CustomerLogin';
import EntityDashboard from './pages/EntityDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
// import VideoConsultation from './pages/VideoConsultation';
import SuccessPayment from './pages/SuccessPayment';
import ResetPassword from './pages/ResetPassword';
import ResetPasswordM from './pages/ResetPasswordM';
import PaymentResult from './pages/PaymentResult';


function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true , v7_startTransition: true}}>
      <div className="App">
        <Routes>
          
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/:prefix" element={<CustomerLogin />} />
          <Route path="/" element={<CustomerLogin />} />
          <Route path="/Entity/login" element={<EntityLogin />} />
          <Route path="/Customer/login" element={<CustomerLogin />} />
          <Route path="/Entity/dashboard" element={<EntityDashboard />} />
          <Route path="/Customer/dashboard" element={<CustomerDashboard />} />
          {/* <Route path="/consultation/:id" element={<VideoConsultation />} /> */}
          <Route path="/success-payment/:id" element={<SuccessPayment />} />
          <Route path="/reset-password/:id" element={<ResetPassword />} />
          <Route path="/reset-passwordM/:id" element={<ResetPasswordM />} />
 
          <Route path="/payment-result" element={<PaymentResult />} />
        </Routes>   
      </div>
    </Router>
  );
}

export default App;